import { streamAgentMessage } from "./agentStreamService";
import {
  createAgentRunnerSession,
  pingAgentRunnerSession,
} from "./agentRunnerClient";
import type { AgentSseHandlers } from "../../utils/parseAgentSseStream";
import type { AgentChatResponse } from "../../types/agentChat";
import { agentApiBase } from "../../utils/agentApiBase";

const AGENT_ID = "developer-guide";

export type DeveloperGuideChatResponse = AgentChatResponse;

export async function createDeveloperGuideSession(): Promise<string> {
  return createAgentRunnerSession(AGENT_ID);
}

export async function pingDeveloperGuideSession(
  sessionId: string,
): Promise<boolean> {
  return pingAgentRunnerSession(AGENT_ID, sessionId);
}

export async function streamDeveloperGuideMessage(
  sessionId: string,
  message: string,
  handlers: AgentSseHandlers = {},
): Promise<DeveloperGuideChatResponse> {
  const base = await agentApiBase(AGENT_ID);
  return streamAgentMessage(
    base,
    sessionId,
    message,
    handlers,
    "Developer guide agent error",
  );
}
